import {
    Insurance,
    InsuranceDetails
} from 'one-state-insurance';


import {
    FhirInsuranceDetails
} from 'one-state-fhirinsurance/src/fhirinsurance-details';


export const TransformInsuranceDetails = (response: any, context: any) => {

    //let responseInsurance:any = patientStubForInsuranceDetails();
    let insurancedata: Insurance[] = [];
    let insuranceresult: any = {
        insurancedata: insurancedata,
        error: undefined
    }
    const { log } = context;
    log.debug("one-epic", "TransformInsuranceDetails transformation entered", response);
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        insuranceresult.error = response;
    }
    if (response && response?.length > 0) {
        response.map((record: any) => {
            if (record?.Coverages?.length > 0) {
                record.Coverages.map((ele: any) => {
                    let insurance: Insurance = {
                        planname: null,
                        groupnumber: null,
                        insurancedetails: undefined
                    };

                    let insurancelist: InsuranceDetails[] = [];
                    insurance.planname = ele?.PlanName ? ele.PlanName : "";
                    insurance.groupnumber = ele?.GroupNumber ? ele.GroupNumber : "";
                    let insobj: InsuranceDetails = {
                        effectivefromdate: ele.EffectiveFromDate ? ele.EffectiveFromDate : "",
                        effectivetodate: ele.EffectiveToDate ? ele.EffectiveToDate : "",
                        producttype: ele.ProductType ? ele.ProductType : "",
                        coveragetype: ele.CoverageType ? ele.CoverageType : ""
                    }
                    insurancelist.push(insobj);
                    insurance.insurancedetails = insurancelist;
                    insurancedata.push(insurance);
                });
            }
        })
    }
    insuranceresult.insurancedata = insurancedata;
    log.debug("one-epic", "TransformInsuranceDetails transformation Completed", insuranceresult);
    return insuranceresult;
}

export const TransformFHIRDetails = (response: any, context: any) => {
/**
* @param result contains the transformed response
*/


    let result: any = {
        fhircoverage: [],
        error: undefined
    }

    const { log } = context;
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error = response;
    }

    if (response && response.length > 0) {
        const rs = response;
        let coveragearray: FhirInsuranceDetails[] = [];
        rs.forEach((ele: any) => {
            let coverageobj: FhirInsuranceDetails = {
                payor: "",
                subscriberid: "",
                startdate: "",
                enddate: "",
                status: ""
            }
            if (ele?.entry && ele?.entry.length > 0) {
                ele.entry.forEach((identifierdata: any) => {
                    coverageobj.status = identifierdata?.status ? identifierdata.status : "";
                    coverageobj.subscriberid = identifierdata?.subscriberId ? identifierdata.subscriberId : "";
                    coverageobj.startdate = identifierdata?.period?.start ? identifierdata.period.start : "";
                    coverageobj.enddate = identifierdata?.period?.end ? identifierdata.period.end : "";
                    if(identifierdata?.payor) {
                        identifierdata?.payor.forEach((payordata: any) => {
                            coverageobj.payor = payordata?.display ? payordata.display : "";
                        })
                    }
                })
            }
            coveragearray.push(coverageobj);
        });
        result.fhircoverage = coveragearray;
    }
    log.debug(
        "ccw-gadget,patientFHIR-epic",
        "patientFHIR-epic transforamtion response ", {
        result
    });

    return result;
}